import React, { useState } from 'react'
import ModalEliminarUnSuministro from './ModalEliminarUnSuministro'

const TablaVerLosSuministrosEnUnPaquete = ({item,validateDeleteSuministro, passActualizarTablaSuministro}) => {
  const [modalOnEliminarSuministros,setmodalOnEliminarSuministros]=useState(false)

  const passSuministro=(data)=>{
    passActualizarTablaSuministro(data)
  }

  const hancleClickEliminar=()=>{
    setmodalOnEliminarSuministros(true)
  }
  return (
    <>
      <tr className="border-b">
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{validateDeleteSuministro?
        <button
        type="button"
        onClick={hancleClickEliminar}
        className="inline-block px-3 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
      >
        Eliminar 
      </button>
      :null}
      </td>
        
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MSRESO}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MSNomG}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PQCaSuSl}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PQCaSuDs}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.CncDes}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.FSmDscUMd}</td>
      </tr>
      {modalOnEliminarSuministros? <ModalEliminarUnSuministro item={item} setmodalOnEliminarSuministros={setmodalOnEliminarSuministros} passSuministro={passSuministro}/>:null}
    </>
  )
}

export default TablaVerLosSuministrosEnUnPaquete